module.exports = __webpack_public_path__ + "static/media/SAF-Regular-01.50dd8fd8.svg";